import React from 'react';
import ListTemplate from '../../../Reusable_Components/ListTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';

const CustomerChangeLogList = () => {
  const fetchUrl = `${API_DOMAIN}${API_ROUTES.customerChangeLog}`;

  const columns = [
    { label: 'Change Type', value: 'change_type' },
    { label: 'Published', value: item => item.published ? 'Yes' : 'No' },
    { label: 'Signature', value: 'signature' },
  ];

  const handleAccessDetails = (id) => {
    window.location.href = `/customer/change-log/details/${id}`;
  };

  return (
    <div>
      <h1>Customer Change Logs</h1>
      <ListTemplate
        fetchUrl={fetchUrl}
        columns={columns}
        onAccessDetails={handleAccessDetails}
      />
    </div>
  );
};

export default CustomerChangeLogList;
